var _circle, _circle2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandLuggage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "filled",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 49,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 49,
    r: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15,43a3,3,0,0,0,3,3H34a3,3,0,0,0,3-3V27H15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34,16H18a3,3,0,0,0-3,3v6H37V19A3,3,0,0,0,34,16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.94,4H29a1,1,0,0,0,0-2H23a1,1,0,0,0,0,2h1.91V14h2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandLuggage);
export default __webpack_public_path__ + "static/media/hand_luggage.e0cfc9e9fcda77809dda6c39312c9dd4.svg";
export { ForwardRef as ReactComponent };